function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { createRef } from "react";
import includes from "lodash/includes";
import filter from "lodash/filter";
import classNames from "classnames";
import SocialMemberBubble from "../containers/SocialMemberBubble";
import { injectIntl } from "react-intl";
import { isEqual } from "lodash";
import { getFilteredGroups, getGroupLabel, isTrainerConversation } from "../utils/SocialGroupsUtils";
import Icon from "./Icon";
// This component renders an overview of selectable groups inside the notes and the activity center
var SocialSphereSelector = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(SocialSphereSelector, _React_Component);
    var _super = _createSuper(SocialSphereSelector);
    function SocialSphereSelector(props) {
        _classCallCheck(this, SocialSphereSelector);
        var _this;
        var _props_filter;
        _this = _super.call(this, props);
        _this.renderGroup = function(group) {
            var _this_props = _this.props, intl = _this_props.intl, isGroupManagementAllowed = _this_props.isGroupManagementAllowed, session = _this_props.session;
            var classes = classNames("sphere-selector__item", {
                "sphere-selector__item--hidden": !group.is_visible
            });
            return group.is_visible || _this.state.displayHidden ? /*#__PURE__*/ React.createElement("li", {
                className: classes,
                key: group.id
            }, /*#__PURE__*/ React.createElement("div", {
                className: "sphere-selector__sphere"
            }, /*#__PURE__*/ React.createElement("button", {
                className: "sphere-selector__sphere-name",
                onClick: _this._onSelect(group)
            }, /*#__PURE__*/ React.createElement(SocialMemberBubble, {
                members: group.members,
                isTrainerConv: isTrainerConversation(group),
                indicator: group.unread_topics ? group.unread_topics : null
            }), /*#__PURE__*/ React.createElement("span", {
                className: "sphere-selector__label"
            }, getGroupLabel(group, intl.formatMessage({
                id: "social.activities.me",
                defaultMessage: "Me"
            }))), group.unread_topics > 0 && /*#__PURE__*/ React.createElement("span", {
                className: "sr-only"
            }, intl.formatMessage({
                id: "social.activities.unread_count",
                defaultMessage: "Unread: {count}. "
            }, {
                count: group.unread_topics
            }))), /*#__PURE__*/ React.createElement("span", {
                className: "sphere-selector__sphere-actions"
            }, isGroupManagementAllowed ? session && group.owner.id === session.id && group.is_visible ? /*#__PURE__*/ React.createElement("button", {
                className: "sphere-selector__action-btn",
                onClick: _this._onEdit(group)
            }, /*#__PURE__*/ React.createElement(Icon, {
                name: "community-edit",
                size: "s"
            }), /*#__PURE__*/ React.createElement("span", {
                className: "sr-only"
            }, intl.formatMessage({
                id: "social.activities.group_edit",
                defaultMessage: "edit group"
            }))) : /*#__PURE__*/ React.createElement("button", {
                className: "sphere-selector__action-btn",
                onClick: _this._onEdit(group, true)
            }, /*#__PURE__*/ React.createElement(Icon, {
                name: "community-info",
                size: "s"
            }), /*#__PURE__*/ React.createElement("span", {
                className: "sr-only"
            }, intl.formatMessage({
                id: "social.activities.group_info",
                defaultMessage: "group info"
            }))) : null, /*#__PURE__*/ React.createElement("button", {
                type: "button",
                className: "sphere-selector__action-btn",
                onClick: _this._onToggleSphereVisibility(group)
            }, /*#__PURE__*/ React.createElement(Icon, {
                name: group.is_visible ? "community-hide" : "community-unhide",
                size: "s"
            }), /*#__PURE__*/ React.createElement("span", {
                className: "sr-only"
            }, group.is_visible ? intl.formatMessage({
                id: "social.spheres.hide_sphere",
                defaultMessage: "hide sphere"
            }) : intl.formatMessage({
                id: "social.spheres.show_sphere",
                defaultMessage: "show sphere"
            })))))) : null;
        };
        _this._onSpheresChanged = function() {
            var _this_props_filter;
            var spheres = ((_this_props_filter = _this.props.filter) === null || _this_props_filter === void 0 ? void 0 : _this_props_filter.length) ? filter(_this.props.groups, function(s) {
                return includes(_this.props.filter, s.id);
            }) : _this.props.groups;
            _this.setState({
                spheres: spheres
            });
        };
        _this._onSearchChanged = function() {
            var _this_search, _this_search_current, _this_props_filter;
            var searched = ((_this_search = _this.search) === null || _this_search === void 0 ? void 0 : (_this_search_current = _this_search.current) === null || _this_search_current === void 0 ? void 0 : _this_search_current.value) ? getFilteredGroups(_this.search.current.value) : _this.props.groups;
            _this.setState({
                spheres: ((_this_props_filter = _this.props.filter) === null || _this_props_filter === void 0 ? void 0 : _this_props_filter.length) ? filter(searched, function(s) {
                    return includes(_this.props.filter, s.id);
                }) : searched
            });
        };
        _this._onSelect = function(group) {
            return function(event) {
                event.preventDefault();
                _this.props.onSelect(group);
            };
        };
        _this._onEdit = function(group) {
            var isInfoView = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return function(event) {
                event.preventDefault();
                event.stopPropagation();
                _this.props.onEdit(group, isInfoView);
            };
        };
        _this._onCreateNew = function() {
            return function(event) {
                event.preventDefault();
                _this.props.onCreate();
            };
        };
        _this._onToggleHidden = function(event) {
            event.preventDefault();
            _this.setState({
                displayHidden: !_this.state.displayHidden
            });
        };
        _this._onToggleSphereVisibility = function(sphere) {
            var toggleGroupVisibility = _this.props.toggleGroupVisibility;
            return function(event) {
                event.preventDefault();
                event.stopPropagation();
                toggleGroupVisibility(sphere);
            };
        };
        _this.search = /*#__PURE__*/ createRef();
        _this.state = {
            spheres: ((_props_filter = props.filter) === null || _props_filter === void 0 ? void 0 : _props_filter.length) ? filter(props.groups, function(s) {
                return includes(props.filter, s.id);
            }) : props.groups,
            displayHidden: false
        };
        return _this;
    }
    var _proto = SocialSphereSelector.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this_props = this.props, groups = _this_props.groups, filter = _this_props.filter;
        if (!isEqual(prevProps.filter, filter) || !isEqual(prevProps.groups, groups)) {
            this._onSpheresChanged();
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, intl = _this_props.intl, className = _this_props.className, isLoadingGroups = _this_props.isLoadingGroups;
        var displayHidden = this.state.displayHidden;
        var visibleSpheres = this.state.spheres.filter(function(s) {
            return s.is_visible;
        });
        var hiddenSpheres = this.state.spheres.filter(function(s) {
            return !s.is_visible;
        });
        var hiddenHasUnread = hiddenSpheres.some(function(s) {
            return s.unread_topics > 0;
        });
        return /*#__PURE__*/ React.createElement("div", {
            className: className
        }, /*#__PURE__*/ React.createElement("div", {
            className: "social-app-options"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "social-app-filter"
        }, /*#__PURE__*/ React.createElement("label", {
            htmlFor: "sphereSearch",
            className: "sr-only"
        }, intl.formatMessage({
            id: "social.activities.search_spheres",
            defaultMessage: "Search spheres"
        })), /*#__PURE__*/ React.createElement("input", {
            id: "sphereSearch",
            onKeyUp: this._onSearchChanged,
            ref: this.search,
            type: "text",
            className: "social-app-options__search social-app-options__search--we"
        }), /*#__PURE__*/ React.createElement("button", {
            onClick: this._onSearchChanged
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "filter",
            size: "s"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "sr-only"
        }, intl.formatMessage({
            id: "social.spheres.filter_spheres",
            defaultMessage: "Filter spheres"
        })))), this.props.isGroupManagementAllowed ? /*#__PURE__*/ React.createElement("button", {
            onClick: this._onCreateNew(),
            className: "social-app-options__btn social-app-options__btn--we"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "add",
            size: "m"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "social-app-options__btn-text"
        }, intl.formatMessage({
            id: "social.activities.new_sphere",
            defaultMessage: "new sphere"
        }))) : null), /*#__PURE__*/ React.createElement("div", {
            className: "sphere-selector"
        }, hiddenHasUnread && !displayHidden ? /*#__PURE__*/ React.createElement("div", {
            className: "sphere-selector__msg"
        }, intl.formatMessage({
            id: "social.spheres.unread_inside_hidden_sphere",
            defaultMessage: "unread inside hidden sphere"
        }), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("button", {
            className: "sphere-selector__msg-button",
            onClick: this._onToggleHidden
        }, intl.formatMessage({
            id: "social.spheres.show_all_spheres",
            defaultMessage: "show all spheres"
        }))) : null, isLoadingGroups ? null : this.state.spheres.length ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("ul", {
            className: "sphere-selector__list"
        }, visibleSpheres.map(function(s) {
            return _this.renderGroup(s);
        })), hiddenSpheres.length ? /*#__PURE__*/ React.createElement("div", {
            className: "sphere-hidden"
        }, /*#__PURE__*/ React.createElement("button", {
            className: "sphere-hidden__button",
            onClick: this._onToggleHidden
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "community-hide",
            size: "s"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "sphere-hidden__button-text"
        }, intl.formatMessage({
            id: "social.spheres.hidden_spheres",
            defaultMessage: "Hidden spheres"
        }))), displayHidden && /*#__PURE__*/ React.createElement("ul", {
            className: "sphere-selector__list",
            "aria-hidden": !displayHidden
        }, hiddenSpheres.map(function(s) {
            return _this.renderGroup(s);
        }))) : null) : /*#__PURE__*/ React.createElement("span", null, intl.formatMessage({
            id: "social.spheres.empty",
            defaultMessage: "You have no spheres yet. Create one!"
        }))));
    };
    return SocialSphereSelector;
}(React.Component);
export default injectIntl(SocialSphereSelector);
